import Loader from './Loader'

const TableLoader = () => {
  return (
    <div className="bg-white h-full min-h-25 flex justify-center items-center">
      <Loader />
    </div>
  )
}

export default TableLoader
